import { api } from '@/services';

import { IIpadConfigUpdate } from '@/features/ipad-configs/interfaces';
import { DEVICES_API_ENDPOINTS } from '@/constants';
import { ApiResponse } from '@/types';

const IpadConfigUpdateService = {
  UpdateIpadConfig: async (
    ipadConfig: IIpadConfigUpdate,
  ): Promise<ApiResponse<IIpadConfigUpdate>> => {
    const response = await api.patch(
      DEVICES_API_ENDPOINTS.DEVICES_SERIAL.replace(':serialNumber', ipadConfig.serialNumber),
      ipadConfig,
    );
    return response.data;
  },
};

export default IpadConfigUpdateService;
